import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=5fa9738b&"
import script from "./Preference.vue?vue&type=script&lang=ts&"
export * from "./Preference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports